import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import InfoTemplate from "../components/InfoTemplate";
import API_BASE_URL from "../api";

const InfoPage = () => {
  // const { dataType, infoId } = useParams();
  const { dataType, slug } = useParams();
  const id = slug.split("-")[0];
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await fetch(
          `${API_BASE_URL}/api/info/${dataType}/${slug}`
        );

        const json = await res.json();
        setData(json);

      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (dataType && slug) {
      fetchData();
    }
  }, [dataType, slug]);

  if (loading) return <div>Loading...</div>;
  if (!data) return <div>No data found</div>;

  return <InfoTemplate data={data} />;
};

export default InfoPage;